<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="open = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-900 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              <div class="">
                <h1 class="uppercase text-turquoise-500 tracking-widest font-light text-center mb-4">Staking Complete</h1>

                <div>

                  <template v-if="tiers.one == 0 && tiers.two == 0 && tiers.three == 0">
                    <div class="w-full flex justify-center items-center h-[10rem]">
                      <p class="text-xl text-white font-light">No Tiers Yet</p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="">
                      <!-- <p class="text-sm text-woodsmoke-200">Your Current Tiers</p> -->

                      <div class="relative flex justify-center items-center">
                        <template v-if="tiers?.one == 0 && tiers?.two == 0 && tiers?.three == 0">
                          <div class="w-full h-[10rem]"></div>
                        </template>

                        <template v-if="tiers?.one == 0 && tiers?.two == 0 && tiers?.three == 1">
                          <img src="https://oxbull-presale.s3.amazonaws.com/tier3.svg" alt="" class="w-[10rem] h-[10rem]" />
                        </template>

                        <template v-if="tiers?.one == 0 && tiers?.two == 1 && tiers?.three == 0">
                          <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[10rem] h-[10rem]" />
                        </template>

                        <template v-if="tiers?.one == 0 && tiers?.two == 2 && tiers?.three == 0">
                          <div class="flex justify-center items-center h-[10rem]">
                            <div class="flex justify-center items-center relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[8rem] h-[8rem] z-10" />
                              <!-- <div class="h-4 w-4 absolute bottom-2 left-2 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 ">1</div> -->
                            </div>
                            <div class="flex justify-center items-center flex-col -ml-[20%]">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[8rem] h-[8rem] scale-90 rotate-12 z-0" />
                            </div>
                          </div>
                        </template>

                        <template v-if="tiers?.one == 1 && tiers?.two == 0 && tiers?.three == 0">
                          <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[10rem] h-[10rem]" />
                        </template>

                        <template v-if="tiers?.one > 1 && tiers?.two == 0 && tiers?.three == 0">
                          <div class="flex justify-center items-center relative">
                            <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[10rem] h-[10rem]" />
                            <div v-if="tiers?.one > 1" class="h-6 w-6 absolute bottom-1 right-1 bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
                          </div>
                        </template>

                        <template v-if="tiers?.one >= 1 && tiers?.two == 1 && tiers?.three == 0">
                          <div class="flex justify-center items-center">
                            <div class="flex justify-center items-center relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[10rem] h-[10rem] z-10" />
                              <!-- <div v-if="tiers?.one > 1" class="h-4 w-4 absolute bottom-1 left-0 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 "> {{ tiers?.one }}</div> -->

                              <div v-if="tiers?.one > 1" class="h-10 w-10 absolute bottom-1 right-0 text-xl bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
                            </div>
                            <div class="flex justify-center items-center flex-col -ml-[20%] relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[8rem] h-[8rem] scale-90 rotate-12 z-0" />
                            </div>
                          </div>
                        </template>

                        <template v-if="tiers?.one >= 1 && tiers?.two == 2 && tiers?.three == 0">
                          <div class="flex justify-center items-center">
                            <div class="flex justify-center items-center flex-col -mr-[20%] relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[8rem] h-[8rem] scale-90 -rotate-12 z-0" />
                            </div>

                            <div class="flex justify-center items-center relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier1.svg" alt="" class="w-[10rem] h-[10rem] z-10" />
                              <!-- <div v-if="tiers?.one > 1" class="h-4 w-4 absolute bottom-1 left-0 bg-turquoise-500 text-turquoise-1000 ring ring-turquoise-300 rounded-full flex justify-center items-center text-xs z-40 "> {{ tiers?.one }}</div> -->

                              <div v-if="tiers?.one > 1" class="h-10 w-10 absolute bottom-1 right-0 text-xl bg-black/80 text-white backdrop-blur-sm ring ring-yellow-500/50 border border-yellow-500 rounded-full flex justify-center items-center font-sans-serif z-40">{{ tiers?.one }}</div>
                            </div>

                            <div class="flex justify-center items-center flex-col -ml-[20%] relative">
                              <img src="https://oxbull-presale.s3.amazonaws.com/tier2.svg" alt="" class="w-[8rem] h-[8rem] scale-90 rotate-12 z-0" />
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div class="flex justify-center flex-col items-center my-4">
                      <p class="text-woodsmoke-200 uppercase tracking-widest text-sm">Your current tier:</p>
                      <div class="flex justify-center items-center space-x-4 text-xl text-white font-light">
                        <p v-if="tiers.one > 0">{{ tiers.one }} X Tier One</p>
                        <p v-if="tiers.two > 0">{{ tiers.two }} X Tier Two</p>
                        <p v-if="tiers.three > 0">{{ tiers.three }} X Tier Three</p>
                      </div>
                    </div>
                  </template>

                  <a :href="explorer_link" target="_blank" class="outline-none flex justify-between w-full items-center p-2 rounded-md bg-white/5 mb-2 text-sm hover:bg-white/10 transition-all duration-200">
                    <p>
                      You just staked <span class="text-white">{{ stake_input }}</span> OXI
                    </p>

                    <div class="capitalize flex space-x-2 items-center" :href="explorer_link">
                      <p>view txn</p>
                      <!-- <span class="text-turquoise-500 iconify" data-icon="ci:link"></span> -->
                      <Icon name="ci:link" class="text-turquoise-500" />
                    </div>
                  </a>

                  <div class="w-full bg-woodsmoke-700 p-2 rounded-md">
                    <p class="text-sm text-turquoise-500">Your Current OXI Staked</p>
                    <p class="text-xl text-white">{{ Math.floor(accountData?.stakes?.amount * 100) / 100 }} OXI</p>
                  </div>

                  <div v-if="tiers.one > 0 || tiers.two > 0 || tiers.three > 0" class="w-full rounded-md mt-4">
                    <div class="flex justify-start items-center space-x-2 text-turquoise-500">
                      <!-- <span class="iconify" data-icon="fluent:megaphone-16-filled"></span> -->
                      <Icon name="fluent:megaphone-16-filled" class="text-turquoise-500" />
                      <p>Join Private Group</p>
                    </div>
                    <p class="text-sm text-woodsmoke-200">You have access to private group, check "your groups" section for invite links.</p>
                  </div>

                  <div class="pt-4">
                    <button @click="close()" class="btn w-full bg-turquoise-500 text-turquoise-900 hover:text-white">Complete</button>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref } from "vue";
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";

const props = defineProps(['accountData'])
const {accountData} = toRefs(props)

const open = ref(false);
const explorer_link = ref("");
const stake_input = ref("");
const tiers = ref({ one: 0, two: 0, three: 0 });

const openModal = (args) => {
  open.value = true;
  explorer_link.value = args.explorer_link;
  stake_input.value = args.stake_input;
  tiers.value = args.tiers;
};

const emit = defineEmits(["showGroup"]);

const close = () => {
  open.value = false;

  if (tiers.value.one > 0 || tiers.value.two > 0 || tiers.value.three > 0) {
    emit("showGroup");
  }
};

defineExpose({
  openModal,
  open,
  explorer_link,
  stake_input,
  tiers,
});
</script>
